import * as React from 'react';
import styled from 'styled-components';
import {
  alignItems,
  color,
  flex,
  flexDirection,
  flexWrap,
  height,
  justifyContent,
  maxHeight,
  space,
  width,
} from 'styled-system';
import { StyledSystemProps } from '../theme/StyledSystemProps';
import { SCREEN } from '../theme/breakpoints';

const isWeb = SCREEN.isWeb;

type Props = StyledSystemProps & {
  color?: string;
  backgroundImage?: string | null;
  children: React.ReactNode;
  backgroundSize?: string;
};

const Container = styled.div`
  ${flex};
  ${space};
  ${color};
  ${width};
  ${height};
  ${flexWrap};
  ${maxHeight};
  ${alignItems};
  ${flexDirection};
  ${justifyContent};
  display: flex;
  box-sizing: border-box;
  background-image: url(${(props: Props) => props.backgroundImage});
  background-repeat: ${(props: Props) => props.backgroundImage && 'no-repeat'};
  background-position: ${(props: Props) => props.backgroundImage && 'center'};
  background-size: ${(props: Props) => props.backgroundImage && 'cover'};
`;

const PageWrap: React.FC<Props> = (props: Props) => {
  return <Container {...props}>{props.children}</Container>;
};

PageWrap.defaultProps = {
  p: isWeb ? 0 : '0 20px',
  flex: 1,
  width: '100%',
  height: '100%',
  bg: 'paleGrey',
  flexDirection: 'row',
  alignItems: 'flex-start',
  justifyContent: 'flex-start',
};

export default PageWrap;
